/* Greenstone · gs-Erweiterungen
   - Herkunft der Anfrage (gclid, UTM, Einstiegsseite) in Formulare schreiben
   - Lead-Event an Shopify Customer Events senden (für Google Ads / GA4 Pixel)
   - Anfrage-Dialog, Vorher/Nachher-Regler, Videos erst bei Klick laden */
(function () {
  if (window.__gsInit) return;
  window.__gsInit = true;

  var KEY = 'gs_src';
  var store = {
    get: function () { try { return JSON.parse(sessionStorage.getItem(KEY) || '{}'); } catch (e) { return {}; } },
    set: function (v) { try { sessionStorage.setItem(KEY, JSON.stringify(v)); } catch (e) {} }
  };

  // Herkunft nur innerhalb der Sitzung merken (kein Cookie, keine Weitergabe)
  var p = new URLSearchParams(location.search);
  var src = store.get();
  ['gclid', 'gbraid', 'wbraid', 'utm_source', 'utm_medium', 'utm_campaign', 'utm_term'].forEach(function (k) {
    if (p.get(k)) src[k] = p.get(k).slice(0, 200);
  });
  if (!src.landing) src.landing = location.pathname;
  if (!src.referrer && document.referrer && document.referrer.indexOf(location.host) === -1) src.referrer = document.referrer.slice(0, 200);
  store.set(src);

  function fillHidden(root) {
    var s = store.get();
    (root || document).querySelectorAll('[data-gs-src]').forEach(function (input) {
      var k = input.getAttribute('data-gs-src');
      if (k === 'page') input.value = location.pathname;
      else if (k === 'channel') input.value = s.gclid || s.gbraid || s.wbraid ? 'Google Ads' : (s.utm_source ? s.utm_source + ' / ' + (s.utm_medium || '') : (s.referrer ? 'Verweis: ' + s.referrer : 'Direkt / Organisch'));
      else input.value = s[k] || '';
    });
  }

  function onSubmit(e) {
    var form = e.target.closest('form[data-gs-lead]');
    if (!form) return;
    fillHidden(form);
    var data = {
      type: form.getAttribute('data-gs-lead'),
      product: (form.querySelector('[name="contact[Gerät]"]') || {}).value || '',
      page: location.pathname
    };
    try { if (window.Shopify && Shopify.analytics && Shopify.analytics.publish) Shopify.analytics.publish('gs_lead', data); } catch (err) {}
    try { (window.dataLayer = window.dataLayer || []).push({ event: 'generate_lead', lead_type: data.type, lead_product: data.product }); } catch (err) {}
    /* Sende-Zustand: verhindert Doppelklick und zeigt, dass etwas passiert */
    var btn = form.querySelector('button[type=submit]');
    if (btn && !e.defaultPrevented) {
      setTimeout(function () { btn.disabled = true; btn.setAttribute('aria-busy', 'true'); btn.dataset.label = btn.textContent; btn.textContent = 'Wird gesendet …'; }, 0);
      window.addEventListener('pageshow', function () { btn.disabled = false; btn.removeAttribute('aria-busy'); if (btn.dataset.label) btn.textContent = btn.dataset.label; }, { once: true });
    }
  }

  function initBA(root) {
    (root || document).querySelectorAll('[data-gs-ba]').forEach(function (el) {
      if (el.__gs) return; el.__gs = true;
      var range = el.querySelector('input[type=range]');
      var set = function () { el.style.setProperty('--gs-pos', range.value + '%'); };
      range.addEventListener('input', set); set();
    });
  }

  document.addEventListener('click', function (e) {
    var open = e.target.closest('[data-gs-open]');
    if (open) {
      var dlg = document.getElementById(open.getAttribute('data-gs-open'));
      if (dlg && dlg.showModal) {
        e.preventDefault();
        var topic = open.getAttribute('data-gs-topic');
        if (topic) { var r = dlg.querySelector('input[name="contact[Anliegen]"][value="' + topic + '"]'); if (r) r.checked = true; }
        fillHidden(dlg); dlg.showModal();
      }
    }
    var close = e.target.closest('[data-gs-close]');
    if (close) { var d = close.closest('dialog'); if (d) d.close(); }
    var play = e.target.closest('[data-gs-video]');
    if (play) {
      var id = play.getAttribute('data-gs-video');
      var iframe = document.createElement('iframe');
      iframe.src = 'https://www.youtube-nocookie.com/embed/' + encodeURIComponent(id) + '?autoplay=1&rel=0';
      iframe.allow = 'autoplay; encrypted-media; picture-in-picture';
      iframe.allowFullscreen = true; iframe.title = play.getAttribute('aria-label') || 'Video';
      play.replaceWith(iframe);
    }
  });
  document.addEventListener('submit', onSubmit, true);

  // Klick auf den Hintergrund schließt den Dialog
  document.addEventListener('click', function (e) {
    if (e.target.tagName === 'DIALOG' && e.target.classList.contains('gs-dialog')) e.target.close();
  });

  function init(root) { fillHidden(root); initBA(root); }
  if (document.readyState !== 'loading') init(); else document.addEventListener('DOMContentLoaded', function () { init(); });
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();

/* GS: Videos nur abspielen, wenn sichtbar; bei reduzierter Bewegung angehalten mit Steuerung */
(function () {
  var vids = document.querySelectorAll('video.gsx-vid');
  if (!vids.length) return;
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  Array.prototype.forEach.call(vids, function (v) {
    v.muted = true;
    if (reduce) { v.removeAttribute('autoplay'); v.pause(); v.controls = true; }
  });
  if (reduce || !('IntersectionObserver' in window)) return;
  var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (e) {
      var v = e.target;
      if (e.isIntersecting) { var p = v.play(); if (p && p.catch) p.catch(function () {}); }
      else { v.pause(); }
    });
  }, { threshold: 0.25 });
  Array.prototype.forEach.call(vids, function (v) { io.observe(v); });
})();

/* GS: Leasing-Anfrage ohne Produkt (Leasing-/Mietkauf-Seite) mit dem Warenkorb vorbelegen */
(function () {
  var forms = document.querySelectorAll('[data-gs-lease-form]');
  if (!forms.length) return;
  var targets = [];
  forms.forEach(function (f) {
    var items = f.querySelector('[data-gs-cart-items]'), total = f.querySelector('[data-gs-cart-total]');
    if (items && !items.value) targets.push({ items: items, total: total });
  });
  if (!targets.length) return;
  fetch((window.Shopify && Shopify.routes ? Shopify.routes.root : '/') + 'cart.js', { headers: { Accept: 'application/json' } })
    .then(function (r) { return r.json(); })
    .then(function (cart) {
      if (!cart || !cart.items || !cart.items.length) return;
      var list = cart.items.map(function (i) { return i.quantity + ' × ' + i.product_title + (i.variant_title ? ' (' + i.variant_title + ')' : ''); }).join(', ');
      var sum = (cart.total_price / 100).toLocaleString('de-DE', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
      targets.forEach(function (t) {
        if (!t.items.value) t.items.value = list;
        if (t.total && !t.total.value) t.total.value = sum;
      });
    })
    .catch(function () {});
})();
